import { defineStore } from 'pinia'
import { getUserInfoApi, type UserInfoRes } from '@ess-v3/api'
import { store } from './index'

export interface IUserState {
  info?: UserInfoRes
  token: string
}

export const useUserStore = defineStore('user', {
  state: (): IUserState => ({
    info: undefined,
    token: '',
  }),
  getters: {
    getUserInfo(): UserInfoRes | undefined {
      return this.info
    },
    getToken(): string {
      return this.token
    },
  },

  actions: {
    setUserInfo(info?: UserInfoRes) {
      this.info = info
    },

    setToken(token: string) {
      this.token = token
    },

    async GetInfo() {
      try {
        const { data } = await getUserInfoApi()
        this.setUserInfo(data)
      } catch (error) {}
    },
  },
})

// 需要在setup以外使用时
export function useUserStoreWidthOut() {
  return useUserStore(store)
}
